import {useRef} from 'react';
import {useNavigate} from 'react-router-dom';

export const useNavigateRef = () => {
    const navigate = useNavigate();
    const navigateRef = useRef(navigate);

    navigateRef.current = navigate;

    return navigateRef;
};
